export const RegistrationStatus = {
  INITIAL: 'Initial',
  SUBMITTED: 'SUBMITTED',
  COMPLETED: 'Completed'
}

export const Species = {
  BOVINE: 'BOVINE',
  OVINE: 'OVINE'
}

export const MemberType = {
  PRODUCER: 'PRODUCER',
  NON_LPA_LIVESTOCK_OWNER: 'NON_LPA_LIVESTOCK_OWNER',
  SALEYARD: 'SALEYARD',
  AGENT: 'AGENT',
  PROCESSOR: 'PROCESSOR',
  INDEPENDENT_BONING_ROOM: 'INDEPENDENT_BONING_ROOM',
  OPERATOR: 'OPERATOR',
  SUPERMARKET: 'SUPERMARKET',
  RETAILER: 'RETAILER',
  FOOD_SERVICE: 'FOOD_SERVICE',
  WHOLESALER: 'WHOLESALER',
  BRAND_OWNER: 'BRAND_OWNER',
  SOFTWARE_DEVELOPER: 'SOFTWARE_DEVELOPER',
  DATA_CONSUMER_OPERATOR: 'DATA_CONSUMER_OPERATOR',
  DATA_CONSUMER_PRODUCER: 'DATA_CONSUMER_PRODUCER'
}

export const AddressType = {
  ADMIN: 'ADMIN',
  BUSINESS: 'BUSINESS',
  COLD_STORE: 'COLD_STORE',
  DELIVERY: 'DELIVERY',
  EXPORT: 'EXPORT',
  FACTORY: 'FACTORY',
  FEEDLOT: 'FEEDLOT',
  HEAD_OFFICE: 'HEAD_OFFICE',
  LAIRAGE: 'LAIRAGE',
  LEGAL: 'LEGAL',
  LIVESTOCK_OFFICE: 'LIVESTOCK_OFFICE',
  MAIL_SERVICE: 'MAIL_SERVICE',
  OFFICE: 'OFFICE',
  PLANT: 'PLANT',
  POSTAL: 'POSTAL',
  PROPERTY: 'PROPERTY',
  REGIONAL_OFFICE: 'REGIONAL_OFFICE',
  REGISTER: 'REGISTER',
  RETAIL: 'RETAIL',
  SALES: 'SALES',
  SALEYARD: 'SALEYARD',
  STATE_OFFICE: 'STATE_OFFICE',
  WAREHOUSE: 'WAREHOUSE',
  WHOLESALE: 'WHOLESALE'
}

export const AddressState = {
  NSW: 'NSW',
  QLD: 'QLD',
  SA: 'SA',
  TAS: 'TAS',
  VIC: 'VIC',
  WA: 'WA',
  ACT: 'ACT',
  NT: 'NT'
}

// AccessType is a level of access embedded in myMSA JWTs
// General users of all types are Restricted. MSA Staff are generally Staff.
// Administrator is generally reserved for engineers and sysadmin.
// Source of truth exists in mymsa-auth
export const AccessType = {
  ADMINISTRATOR: 'Administrator',
  STAFF: 'Staff',
  RESTRICTED: 'Restricted',
  AUS_MEAT: 'AusMeat'
}

export const ContactDetailType = {
  PHONE: 'PHONE',
  MOBILE: 'MOBILE',
  FAX: 'FAX',
  EMAIL: 'EMAIL',
  WEBSITE: 'WEBSITE'
}

export const LicenseStatus = {
  CURRENT: 'CURRENT',
  INACTIVE: 'INACTIVE',
  ALLIANCE: 'ALLIANCE',
  PENDING: 'PENDING',
  TERMINATED: 'TERMINATED'
}

export const MemberNumberAllocationType = {
  REGISTRATION: 'REGISTRATION',
  MIGRATION: 'MIGRATION',
  LPA: 'LPA'
}

export const SourceOfTruth = {
  LPA: 'LivestockProductionAssurance',
  MSA: 'MeatStandardsAustralia',
  INFOSYS: 'InfoSys'
}
